import { render, staticRenderFns } from "./businessLicenseInfo.vue?vue&type=template&id=47f08cd0&scoped=true"
import script from "./businessLicenseInfo.vue?vue&type=script&lang=js"
export * from "./businessLicenseInfo.vue?vue&type=script&lang=js"
import style0 from "./businessLicenseInfo.vue?vue&type=style&index=0&id=47f08cd0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f08cd0",
  null
  
)

export default component.exports